import { logEvent } from 'firebase/analytics';
import { analytics } from './config';

export function logAnalyticsEvent(event: string, params?: Record<string, unknown>) {
  logEvent(analytics, event, params);
}


